import { useState } from 'react';
import { apiFetch } from '../../lib/api.js';
import { useToast } from '../Toast.js';

interface Props {
  orgId: string;
  initial: Array<{ question: string; answer: string }>;
  onSaved: () => void;
}

export function FaqSection({ orgId, initial, onSaved }: Props) {
  const { toast } = useToast();
  const [faq, setFaq] = useState(initial.length > 0 ? initial : [
    { question: 'What should I wear to class?', answer: 'Comfortable athletic clothing. We provide any equipment you need.' },
    { question: 'Do you offer free trials?', answer: 'Yes! Contact us to schedule your free trial class.' },
    { question: 'What age groups do you teach?', answer: 'We have programs for all ages, from kids to adults.' },
  ]);
  const [isSaving, setIsSaving] = useState(false);

  const save = async () => {
    setIsSaving(true);
    try {
      await apiFetch(`/orgs/${orgId}/site-content/faq`, { method: 'PUT', body: JSON.stringify({ faq: faq.filter(f => f.question && f.answer) }) });
      toast('success', 'FAQ saved — site rebuilding');
      onSaved();
    } catch { toast('error', 'Failed to save'); }
    finally { setIsSaving(false); }
  };

  return (
    <div className="space-y-3">
      {faq.map((item, i) => (
        <div key={i} className="space-y-1.5 p-3 bg-gray-50 rounded-lg">
          <div className="flex gap-2">
            <input type="text" value={item.question} placeholder="Question"
              onChange={e => { const n = [...faq]; n[i] = { ...item, question: e.target.value }; setFaq(n); }}
              className="flex-1 rounded-lg border border-gray-200 px-3 py-1.5 text-sm font-medium" />
            <button onClick={() => setFaq(faq.filter((_, j) => j !== i))} className="text-xs text-red-400 hover:text-red-600 px-2">×</button>
          </div>
          <textarea value={item.answer} placeholder="Answer" rows={2}
            onChange={e => { const n = [...faq]; n[i] = { ...item, answer: e.target.value }; setFaq(n); }}
            className="w-full rounded-lg border border-gray-200 px-3 py-1.5 text-xs resize-vertical" />
        </div>
      ))}
      {faq.length < 20 && (
        <button onClick={() => setFaq([...faq, { question: '', answer: '' }])}
          className="text-sm text-primary-600 hover:text-primary-800 font-medium">+ Add question</button>
      )}
      <div>
        <button onClick={save} disabled={isSaving}
          className="px-4 py-2 text-sm font-medium bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 transition-colors">
          {isSaving ? 'Saving...' : 'Save FAQ'}
        </button>
      </div>
    </div>
  );
}
